var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import { Badge } from "../badge/Badge";
import { Icon } from "../icon/Icon";
export var IconWithModifier = function (props) {
    var modifierIconProps = props.modifierIconProps, iconProps = __rest(props, ["modifierIconProps"]);
    return (React.createElement("div", { className: "pos-rel" },
        React.createElement(Icon, __assign({}, iconProps)),
        modifierIconProps && (React.createElement(Badge, { position: modifierIconProps.position },
            React.createElement(Icon, __assign({}, modifierIconProps))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon-with-modifier/IconWithModifier.tsx
// module id = 224
// module chunks = 3